// ============================================================================
// BotaoLinkAssinatura · busca (via contract-signlink) o link de assinatura do
// CLIENTE no D4Sign e copia pro clipboard. Só entrega o link quando a
// assinatura interna (Reach Up) já foi concluída e o cliente ainda não assinou;
// senão, mostra um aviso explicando o estágio.
// ============================================================================

import { useState, type MouseEvent } from "react";
import { supabase } from "../lib/supabase";
import { useToast } from "./Toast";

interface SignLinkResp {
  ok?: boolean;
  link?: string;
  message?: string;
  internalSigned?: boolean;
  clientSigned?: boolean;
}

export function BotaoLinkAssinatura({
  doc,
  clientNome,
  compacto,
}: {
  doc: string | null | undefined;
  clientNome?: string | null;
  compacto?: boolean;
}) {
  const { show } = useToast();
  const [busy, setBusy] = useState(false);
  if (!doc) return null;

  async function copiar(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      const { data, error } = await supabase.functions.invoke<SignLinkResp>("contract-signlink", { body: { doc } });
      if (error || !data) {
        show("error", "Não consegui consultar a assinatura no D4Sign.");
        return;
      }
      if (data.link) {
        const quem = clientNome ? ` (${clientNome})` : "";
        try {
          await navigator.clipboard.writeText(data.link);
          show("success", `Link de assinatura do cliente copiado${quem}. É só colar pro cliente assinar.`);
        } catch {
          window.prompt(`Link de assinatura do cliente${quem} — copie e envie:`, data.link);
        }
      } else {
        show(data.clientSigned ? "info" : "warning", data.message || "Link de assinatura ainda não disponível.");
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      type="button"
      className="btn btn-ghost"
      style={compacto ? { fontSize: 12, padding: "3px 9px" } : undefined}
      disabled={busy}
      onClick={copiar}
      title="Copiar o link de assinatura do cliente (D4Sign)"
    >
      {busy ? "Buscando…" : compacto ? "Copiar link" : "Copiar link de assinatura do cliente"}
    </button>
  );
}
